// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf } from "@altostra/type-validations";
import { string } from "@altostra/type-validations/lib/primitives";

export const isAppSettingsInternalUserGroupsTestUserAppDataResult = objectOf({
  ip_address: string,
  apps: arrayOf(
    objectOf({
      name: string,
      type: string,
      api_key: string,
    })
  ),
});
